import React, { useState, useEffect } from "react";
import './App.css';
//import KakaoMap from './KakaoMap';
import RouteTab from './route';
import SearchTab from './search';
import ConnectTab from './connect';
import HomeTab from "./home";
import Map from "./Map";
// import Info from "./Info";
// import MyPage from "./MyPage";
// import Settings from "./Settings";

// 시/도, 시/군 데이터 예시 (실제 데이터는 더 추가 가능)

function App() {
  // hash에서 페이지 추출
  const getPageFromHash = () => {
    const hash = window.location.hash.replace("#/", "");
    const [page] = hash.split("?");
    return page || "home";
  };

  // hash에서 쿼리 파싱
  const getQueryFromHash = () => {
    const hash = window.location.hash.replace("#/", "");
    const [, queryString] = hash.split("?");
    return new URLSearchParams(queryString || "");
  };

  const [selectedPage, setSelectedPage] = useState(getPageFromHash);
  const [mapParams, setMapParams] = useState(getQueryFromHash);
  const [routeViewData, setRouteViewData] = useState(() => {
    const saved = localStorage.getItem('routeViewData');
    return saved ? JSON.parse(saved) : null;
  });
  const [routeInfo, setRouteInfo] = useState(() => {
    const saved = localStorage.getItem('routeInfo');
    return saved ? JSON.parse(saved) : null;
  });
  const [routeList, setRouteList] = useState(() => {
    const saved = localStorage.getItem('routeList');
    return saved ? JSON.parse(saved) : [];
  });
  const [labels, setLabels] = useState(() => {
    const saved = localStorage.getItem('labels');
    return saved ? JSON.parse(saved) : {};
  });
  const [connectGroups, setConnectGroups] = useState(() => {
    const saved = localStorage.getItem('connectGroups');
    return saved ? JSON.parse(saved) : [];
  });
  const [checkedList, setCheckedList] = useState(() => {
    const saved = localStorage.getItem('checkedList');
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedSido, setSelectedSido] = useState(() => localStorage.getItem('selectedSido') || "");
  const [selectedSigungu, setSelectedSigungu] = useState(() => localStorage.getItem('selectedSigungu') || "");
  const [cityCode, setCityCode] = useState(() => {
    const saved = localStorage.getItem('cityCode');
    return saved ? JSON.parse(saved) : null;
  });
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem('zoom');
    return saved ? JSON.parse(saved) : 1;
  });
  const [showAllMarkers, setShowAllMarkers] = useState(() => {
    const saved = localStorage.getItem('showAllMarkers');
    return saved ? JSON.parse(saved) : true;
  });

  // hash와 상태를 동기화하는 setSelectedPage 커스텀 함수
  const setSelectedPageWithHash = (page) => {
    window.location.hash = `/${page}`;
    setSelectedPage(page);
  };

  // hash 변경 시 페이지 변경
  useEffect(() => {
    const onHashChange = () => {
      setSelectedPage(getPageFromHash());
      setMapParams(getQueryFromHash());
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  // 상태 변경 시 localStorage에 저장
  useEffect(() => { localStorage.setItem('selectedTab', selectedPage); }, [selectedPage]);
  useEffect(() => { localStorage.setItem('routeViewData', JSON.stringify(routeViewData)); }, [routeViewData]);
  useEffect(() => { localStorage.setItem('routeInfo', JSON.stringify(routeInfo)); }, [routeInfo]);
  useEffect(() => { localStorage.setItem('routeList', JSON.stringify(routeList)); }, [routeList]);
  useEffect(() => { localStorage.setItem('labels', JSON.stringify(labels)); }, [labels]);
  useEffect(() => { localStorage.setItem('connectGroups', JSON.stringify(connectGroups)); }, [connectGroups]);
  useEffect(() => { localStorage.setItem('checkedList', JSON.stringify(checkedList)); }, [checkedList]);
  useEffect(() => { localStorage.setItem('selectedSido', selectedSido); }, [selectedSido]);
  useEffect(() => { localStorage.setItem('selectedSigungu', selectedSigungu); }, [selectedSigungu]);
  useEffect(() => { localStorage.setItem('cityCode', JSON.stringify(cityCode)); }, [cityCode]);
  useEffect(() => { localStorage.setItem('zoom', JSON.stringify(zoom)); }, [zoom]);
  useEffect(() => { localStorage.setItem('showAllMarkers', JSON.stringify(showAllMarkers)); }, [showAllMarkers]);

  // 노선 정보를 달러($)로 연결, 여러 노선은 세미콜론으로 연결 (정류소명 포함)
  const serializeRoute = (route) => [
    route.routeId,
    route.cityCode,
    route.routeType,
    route.routeName,
    route.boarding?.lat,
    route.boarding?.lng,
    route.boarding?.name || "",
    route.alighting?.lat,
    route.alighting?.lng,
    route.alighting?.name || "",
    route.label || ""
  ].map(v => encodeURIComponent(v ?? "")).join("$");

  const parseRoute = (str) => {
    const [
      routeId, cityCode, routeType, routeName,
      boardingLat, boardingLng, boardingName,
      alightingLat, alightingLng, alightingName,
      label
    ] = str.split("$");
    return {
      routeId: decodeURIComponent(routeId),
      cityCode: decodeURIComponent(cityCode),
      routeType: decodeURIComponent(routeType),
      routeName: decodeURIComponent(routeName),
      boarding: {
        lat: parseFloat(decodeURIComponent(boardingLat)),
        lng: parseFloat(decodeURIComponent(boardingLng)),
        name: decodeURIComponent(boardingName)
      },
      alighting: {
        lat: parseFloat(decodeURIComponent(alightingLat)),
        lng: parseFloat(decodeURIComponent(alightingLng)),
        name: decodeURIComponent(alightingName)
      },
      label: decodeURIComponent(label)
    };
  };

  // 여러 노선 동시 지도에서 보기 (routeData: 단일 or 배열, labelsArr: 라벨 배열, title: 지도 타이틀)
  const handleShowOnMap = (routeData, labelsArr, title) => {
    let routesToShow = Array.isArray(routeData) ? routeData : [routeData];
    // labelsArr가 있으면 각 route에 label을 붙여줌
    if (labelsArr && Array.isArray(labelsArr)) {
      routesToShow = routesToShow.map((r, i) => ({ ...r, label: labelsArr[i] || "" }));
    }
    const routesParam = routesToShow.map(serializeRoute).join(";");
    const hashTitle = title ? `&title=${encodeURIComponent(title)}` : '';
    window.location.hash = `/map?routes=${routesParam}${hashTitle}`;
  };

  // routeList가 바뀌면 checkedList도 동기화
  useEffect(() => {
    setCheckedList(routeList.map(() => true));
  }, [routeList]);

  // routeList와 labels 동기화: 노선 추가/삭제 시 labels도 같이 처리
  useEffect(() => {
    setLabels(prev => {
      let arr = Array.isArray(prev) ? [...prev] : [];
      if (routeList.length > arr.length) {
        // 노선이 추가된 경우
        return [...arr, ...Array(routeList.length - arr.length).fill("")];
      } else if (routeList.length < arr.length) {
        // 노선이 삭제된 경우
        return arr.slice(0, routeList.length);
      }
      return arr;
    });
  }, [routeList]);

  // 체크박스 변경 핸들러
  const handleCheck = (idx) => {
    setCheckedList(prev => prev.map((v, i) => i === idx ? !v : v));
  };
  
  // 지도에서 "선택 완료" 시 노선탭으로 이동
  const handleCompleteSelection = (info) => {
    setRouteList(prev => {
      // 동일 승하차 정류장명이 있는지 확인
     // const sameStopIdx = prev.findIndex(item =>
      //  item.boarding?.name === info.boarding?.name &&
     //   item.alighting?.name === info.alighting?.name
     // );
    //  if (sameStopIdx !== -1) {
        // 이미 존재하면 routeName 병기 (중복 routeName 방지)
     //   const newList = [...prev];
     //   const existNames = newList[sameStopIdx].routeName ? newList[sameStopIdx].routeName.split(',').map(s => s.trim()) : [];
     ////   if (!existNames.includes(info.routeName)) {
       //   newList[sameStopIdx].routeName = existNames.concat(info.routeName).join(', ');
      //  }
      //  return newList;
      //} else {
        // 기존 중복 제거 후 맨 위에 추가
        const filtered = prev.filter(
          item =>
            !(
              item.routeId === info.routeId &&
              item.cityCode === info.cityCode &&
              item.boarding?.lat === info.boarding?.lat &&
              item.boarding?.lng === info.boarding?.lng &&
              item.alighting?.lat === info.alighting?.lat &&
              item.alighting?.lng === info.alighting?.lng
            )
        );
        return [info, ...filtered];
      //}
    });
    setLabels(prev => {
      let arr = Array.isArray(prev) ? [...prev] : [];
      // 새 노선이 맨 앞에 추가되는 경우 info.label(있으면) 또는 기본값("")
      return [info.label || "", ...arr];
    });
    setSelectedPageWithHash("route");
  };

  // 노선 삭제 시 labels도 동기화
  const handleDeleteRoute = (idx) => {
    setRouteList(prev => prev.filter((_, i) => i !== idx));
    setLabels(prev => {
      let arr = Array.isArray(prev) ? [...prev] : [];
      arr.splice(idx, 1);
      return arr;
    });
  };

  // 노선 순서 변경 함수 추가
  const handleReorderRoutes = (fromIndex, toIndex) => {
    setRouteList(prev => {
      const newList = [...prev];
      const [movedItem] = newList.splice(fromIndex, 1);
      newList.splice(toIndex, 0, movedItem);
      return newList;
    });
    
    setLabels(prev => {
      let arr = Array.isArray(prev) ? [...prev] : [];
      const [movedLabel] = arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, movedLabel);
      return arr;
    });
    
    setCheckedList(prev => {
      const newCheckedList = [...prev];
      const [movedChecked] = newCheckedList.splice(fromIndex, 1);
      newCheckedList.splice(toIndex, 0, movedChecked);
      return newCheckedList;
    });
  };

  // 텍스트 입력 변경 핸들러
  const handleLabelChange = (idx, value) => {
    setLabels(prev => {
      let arr = Array.isArray(prev) ? [...prev] : [];
      arr[idx] = value;
      return arr;
    });
    setRouteList(prev => {
      let arr = [...prev];
      if (arr[idx]) arr[idx] = { ...arr[idx], label: value };
      return arr;
    });
  };

  // 연결 그룹 삭제 핸들러
  const handleDeleteGroup = (groupIdx) => {
    setConnectGroups(prev => prev.filter((_, i) => i !== groupIdx));
  };

  // 연결 그룹 라벨 변경 핸들러
  const handleConnectLabelChange = (groupIdx, routeIdx, value) => {
    setConnectGroups(prev => {
      const newGroups = [...prev];
      if (newGroups[groupIdx]) {
        // labels가 배열이 아니면 배열로 변환
        let labelsArr = Array.isArray(newGroups[groupIdx].labels)
          ? [...newGroups[groupIdx].labels]
          : [];
        // 해당 인덱스에 값 할당
        labelsArr[routeIdx] = value;
        newGroups[groupIdx] = {
          ...newGroups[groupIdx],
          labels: labelsArr
        };
      }
      return newGroups;
    });
  };

  // 연결 그룹 추가 핸들러
  const handleAddGroup = (group) => {
    setConnectGroups(prev => [...prev, group]);
  };

  // 그룹명(타이틀) 변경 핸들러
  const handleChangeGroupTitle = (idx, newTitle) => {
    setConnectGroups(prev => prev.map((g, i) => i === idx ? { ...g, title: newTitle } : g));
  };

  // 노선도 그리기 버튼 핸들러 (RouteTab에서 호출)
  window.handleDrawAllRoutes = () => {
    if (routeList.length > 0) {
      const filteredRoutes = routeList.filter((_, idx) => checkedList[idx]);
      // 체크된 항목에 맞춰 labels도 정확히 매칭
      const labelArr = checkedList
        .map((checked, idx) => checked ? labels[idx] || "" : null)
        .filter(v => v !== null);
      // routeType도 명확히 복사
      const routes = filteredRoutes.map(({ label, ...rest }) => ({ ...rest, routeType: rest.routeType }));
      // 역순으로 그룹화
      const reversedRoutes = routes.reverse();
      const reversedLabels = labelArr.reverse();
      const groupToAdd = { routes: reversedRoutes, labels: reversedLabels };
      setConnectGroups(prev => [groupToAdd, ...prev]); // 맨 위에 추가
    }
    setSelectedPageWithHash('connect');
  };

  // 탭 클릭 시 hash 변경
  const handleTabChange = (tab) => {
    window.location.hash = `/${tab}`;
  };

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, overflow: "hidden" }}>
        {selectedPage === "map" ? (
          <Map
            open={true}
            onClose={() => window.history.back()}
            routes={(() => {
              const routesParam = mapParams.get("routes") || "";
              return routesParam
                .split(";")
                .filter(Boolean)
                .map(parseRoute);
            })()}
            labels={(() => {
              const routesParam = mapParams.get("routes") || "";
              return routesParam
                .split(";")
                .filter(Boolean)
                .map(str => decodeURIComponent(str.split("$")[10] || ""));
            })()}
            title={mapParams.get("title") || (() => {
              const routesParam = mapParams.get("routes") || "";
              const routesArr = routesParam.split(";").filter(Boolean).map(parseRoute);
              if (routesArr.length === 1) return routesArr[0].routeName;
              return "노선 지도";
            })()}
            showAllMarkers={showAllMarkers}
            // 필요시 zoom 등 추가
          />
        ) : (
          <>
            {selectedPage === "route" && <RouteTab 
              routeList={routeList} 
              onDeleteRoute={handleDeleteRoute}
              labels={labels}
              onLabelChange={handleLabelChange}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleCheck={handleCheck}
              showAllMarkers={showAllMarkers}
              onShowOnMap={handleShowOnMap}
              onReorderRoutes={handleReorderRoutes}
            />}
            {selectedPage === "search" && <SearchTab 
              onShowOnMap={handleShowOnMap} 
              onCompleteSelection={handleCompleteSelection}
              selectedSido={selectedSido}
              setSelectedSido={setSelectedSido}
              selectedSigungu={selectedSigungu}
              setSelectedSigungu={setSelectedSigungu}
              cityCode={cityCode}
              setCityCode={setCityCode}
            />}
            {selectedPage === "connect" && <ConnectTab connectGroups={connectGroups} onDeleteGroup={handleDeleteGroup} onLabelChange={handleConnectLabelChange} onAddGroup={handleAddGroup} onChangeGroupTitle={handleChangeGroupTitle} zoom={zoom} setZoom={setZoom} showAllMarkers={showAllMarkers} onShowOnMap={handleShowOnMap} />}
            {selectedPage === "home" && <HomeTab onShowOnMap={handleShowOnMap} onCompleteSelection={handleCompleteSelection} selectedSido={selectedSido} setSelectedSido={setSelectedSido} selectedSigungu={selectedSigungu} setSelectedSigungu={setSelectedSigungu} cityCode={cityCode} setCityCode={setCityCode} zoom={zoom} setZoom={setZoom} showAllMarkers={showAllMarkers} setShowAllMarkers={setShowAllMarkers} />}
          </>
        )}
      </div>
      <nav style={{
        height: 80,
        borderTop: "3px solid #eee",
        display: "flex",
        background: "#fff",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
        paddingBottom: "30px",
        zIndex: 1000
      }}>
        <TabButton label={
          <div style={{ position: 'relative', width: 32, height: 32 }}>
            <img src={process.env.PUBLIC_URL + "/home.png"} alt="home" style={{ width: 32, height: 32, opacity: 0.2 }} />
            <span style={{
              position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#000', fontWeight: 'bold', fontSize: 16, pointerEvents: 'none', textShadow: '0 0 4px #fff'
            }}>홈</span>
          </div>
        } tab="home" selectedTab={selectedPage} onClick={handleTabChange}/>
        <TabButton label={
          <div style={{ position: 'relative', width: 32, height: 32 }}>
            <img src={process.env.PUBLIC_URL + "/magnifier.png"} alt="search" style={{ width: 32, height: 32, opacity: 0.2 }} />
            <span style={{
              position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#000', fontWeight: 'bold', fontSize: 16, pointerEvents: 'none', textShadow: '0 0 4px #fff'
            }}>검색</span>
          </div>
        } tab="search" selectedTab={selectedPage} onClick={handleTabChange} />
        <TabButton label={
          <div style={{ position: 'relative', width: 32, height: 32 }}>
            <img src={process.env.PUBLIC_URL + "/route.png"} alt="route" style={{ width: 32, height: 32, opacity: 0.2 }} />
            <span style={{
              position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#000', fontWeight: 'bold', fontSize: 16, pointerEvents: 'none', textShadow: '0 0 4px #fff'
            }}>노선</span>
          </div>
        } tab="route" selectedTab={selectedPage} onClick={handleTabChange} />
        <TabButton label={
          <div style={{ position: 'relative', width: 32, height: 32 }}>
            <img src={process.env.PUBLIC_URL + "/chain.png"} alt="connect" style={{ width: 32, height: 32, opacity: 0.2 }} />
            <span style={{
              position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#000', fontWeight: 'bold', fontSize: 16, pointerEvents: 'none', textShadow: '0 0 4px #fff'
            }}>그룹</span>
          </div>
        } tab="connect" selectedTab={selectedPage} onClick={handleTabChange} />
      </nav>
    </div>
  );
}

function TabButton({ label, tab, selectedTab, onClick }) {
  return (
    <button
      onClick={() => onClick(tab)}
      style={{
        flex: 1,
        border: "none",
        background: "none",
        fontSize: 1,
        color: selectedTab === tab ? "#3498db" : "#888",
        fontWeight: selectedTab === tab ? "bold" : "normal",
        borderTop: selectedTab === tab ? "3px solid #3498db" : "none",
        padding: "0px 0",
        lineHeight: "1",
        cursor: "pointer"
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', height: 60 }}>
        <span style={{ marginTop: 4, marginBottom: 0 }}>{label}</span>
      </div>
    </button>
  );
}

export default App;
